export default __webpack_public_path__ + "c6d5bcb61c3876713bed29504bc5ba75.png";